import React, {useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';

import './admin.css';
import clsx from 'clsx';

interface IPaymentPage {
    setCurrentPageClass: React.Dispatch<React.SetStateAction<string>>;
    children: React.ReactNode;
}

export default function AdminTemplate({children, setCurrentPageClass}: IPaymentPage) {
    useEffect(() => {
        setCurrentPageClass('bg payment');
    });

    const links = [
        {label: 'Счета', path: '/admin/invoices'},
    ];

    const location = useLocation();

    const routeMap: Record<string, any> = {
        '/admin': {title: 'Админ. панель', baseRoute: '/admin'},
        '/admin/invoices': {title: 'Оплата услуг', baseRoute: '/admin/invoices'},
    };

    return (
        <section className={'content'}>
            <div className={'header'}>
                <h1 className={'title'}>
                    <span>Админка</span>
                </h1>
            </div>
            <nav className="nav-tabs">
                {links.map(link => (
                    <Link
                        key={link.path}
                        to={link.path}
                        className={clsx('tab-link', {active: routeMap[location.pathname]?.baseRoute === link.path})}
                    >
                        {link.label}
                    </Link>
                ))}
            </nav>
            <div className={'workspace'}>
                <section className={'content'}>{children}</section>
            </div>
        </section>
    );
}
